import { cn } from '@/shared/lib/cn';
import { cx } from './lib/tv';

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Round placeholder (avatars). */
  circle?: boolean;
}

/** Loading placeholder bar — White/5 (`#FFFFFF0D`, 03-modules §2.6), r4, gentle pulse. Size it with classes. */
export function Skeleton({ circle, className, ...rest }: SkeletonProps) {
  return (
    <div
      aria-hidden
      {...rest}
      className={cx('animate-pulse bg-subtle', circle ? 'rounded-full' : 'rounded-4', 'h-12 w-full', className)}
    />
  );
}

/** A few text lines of decreasing width. */
export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div aria-hidden className={cn('flex flex-col gap-8', className)}>
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} className={cn('h-12', i === lines - 1 ? 'w-3/5' : i % 2 ? 'w-4/5' : 'w-full')} />
      ))}
    </div>
  );
}
